export default __webpack_public_path__ + "static/media/Jane_Jacobs.c7eae8c0.jpg";